var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const TABLE_TYPES = {
  ALL: { label: "All", value: "all" },
  HOME: { label: "Home", value: "home" },
  AWAY: { label: "Away", value: "away" }
};
const DetailTypeEnum = {
  Match: 1,
  Team: 2,
  League: 3
};
const mapTablesData = (data) => {
  const rules = {};
  const teams = {};
  data.rules.forEach((rule) => {
    rules[rule.id] = rule;
  });
  data.teams.forEach((team) => {
    teams[team.id] = team;
  });
  return data.tables.map((table) => {
    for (const key in table) {
      table[key] = table[key].map((tableData) => {
        return __spreadProps(__spreadValues({}, tableData), {
          items: tableData.items.map((item) => {
            var _a;
            return __spreadProps(__spreadValues({
              key: item.teamId
            }, item), {
              team: __spreadProps(__spreadValues({}, teams[item.teamId]), {
                position: item.position,
                colorCode: (_a = rules[item.ruleId]) == null ? void 0 : _a.colorCode
              })
            });
          })
        });
      });
    }
    return table;
  });
};
export {
  DetailTypeEnum,
  TABLE_TYPES,
  mapTablesData
};
